import { createComponentStore } from '../../utils/createComponentStore';

const defaultData = () => ({
  outputKey: 'payload',
});

const onLoadData = (rawData) => {
  const data = { ...defaultData(), ...rawData };
  // v1 compat: outputPlaceholderKey → outputKey
  if (!data.outputKey && rawData.outputPlaceholderKey) {
    data.outputKey = rawData.outputPlaceholderKey;
  }
  delete data.outputPlaceholderKey;
  return data;
};

const { getStore, defaultStore } = createComponentStore({
  type: 'webhook_trigger',
  endpoint: 'webhook-trigger',
  registryKey: 'webhook-trigger',
  initData: defaultData,
  onLoadData,

  extraActions: (set, get) => ({
    setOutputPlaceholderKey: (val) =>
      set((s) => ({
        data: { ...s.data, outputKey: val },
      })),

    getTemplate: () => {
      const s = get();
      return {
        componentId: s.componentId,
        name: s.name,
        position: s.position,
        data: JSON.parse(JSON.stringify(s.data)),
        type: s.type,
        lastModified: s.lastModified,
      };
    },
  }),
});

export const getWebhookTriggerStore = getStore;
export default defaultStore;
